import { useEffect, useState } from 'react'
import { api } from '../../api/client'

type History = Awaited<ReturnType<typeof api.activity>>
const label = (value: string) => value.replace(/_/g, ' ')

function detail(text: string) {
  try {
    const value = JSON.parse(text)
    if (!value || typeof value !== 'object') return text
    return [typeof value.reason === 'string' ? value.reason : '',
      typeof value.previous_state === 'string' && typeof value.state === 'string'
        ? `${label(value.previous_state)} → ${label(value.state)}` : '',
      typeof value.open_fields === 'number' ? `${value.open_fields} questions remain open` : '',
    ].filter(Boolean).join(' · ') || 'Recorded'
  } catch { return text || 'Recorded' }
}

export default function ActivityHistory({ companyId }: { companyId: string }) {
  const [history, setHistory] = useState<History>({ rows: [], next_cursor: null })
  const [cursor, setCursor] = useState<number>()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)
  useEffect(() => { setCursor(undefined) }, [companyId])
  useEffect(() => {
    let live = true
    setLoading(true)
    const refresh = () => api.activity(companyId, cursor).then(result => {
      if (live) { setHistory(result); setError(''); setLoading(false) }
    }).catch(e => { if (live) { setError(e.message); setLoading(false) } })
    void refresh()
    // Historical pages stay fixed; the newest page refreshes as work proceeds.
    const timer = cursor === undefined ? window.setInterval(refresh, 4000) : undefined
    return () => { live = false; if (timer !== undefined) window.clearInterval(timer) }
  }, [companyId, cursor])
  return <section className="panel">
    <h2>Activity history</h2>
    {error && <p className="notice crit" role="alert">{error}</p>}
    {loading ? <p className="muted">Loading activity…</p> : !history.rows.length ? <p className="muted">No activity recorded.</p> :
      <div className="table-wrap"><table className="data"><thead><tr><th>When</th><th>Action</th><th>Who</th><th>Details</th></tr></thead>
        <tbody>{history.rows.map(row => <tr key={row.id}>
          <td>{new Date(row.created_at).toLocaleString()}</td><td>{label(row.action)}</td><td>{row.actor}</td><td className="wrap">{detail(row.detail)}</td>
        </tr>)}</tbody></table></div>}
    <div className="toolbar">
      {cursor !== undefined && <button className="btn small secondary" disabled={loading} onClick={() => setCursor(undefined)}>Latest activity</button>}
      {history.next_cursor !== null && <button className="btn small secondary" disabled={loading} onClick={() => setCursor(history.next_cursor ?? undefined)}>Older activity</button>}
    </div>
  </section>
}
